<nb-card>
  <nb-card-header>
    <div class="header">
      <span>Wartungstimer</span>
      @if (isAdmin()) {
        <button nbButton status="primary" (click)="addMaintenanceTimer.emit()">
          <nb-icon icon="plus-outline" pack="eva"></nb-icon>
        </button>
      }
    </div>
  </nb-card-header>
  <nb-card-body>
    <form [formGroup]="form" (ngSubmit)="triggerSearch()">
      @if (isAdmin()) {
        <div>
          <label class="label" for="tenantSelect">Kunde</label>
          <wr-tenant-select id="tenantSelect" formControlName="tenantId"
                            [tenantType]="TenantTypeEnum.External"
                            [showEmptyOption]="true">
          </wr-tenant-select>
        </div>
      }
      @if (isContractor()) {
        <div>
          <label class="label" for="customerSelect">Kunde</label>
          <wr-fixed-tenant-select id="customerSelect"
                                  data-cy="contractor-customer-select"
                                  formControlName="customer"
                                  [tenants]="contractorCustomers()"
                                  [showEmptyOption]="true"></wr-fixed-tenant-select>
        </div>
      }
      <div>
        <label class="label" for="buildingSelect">Gebäude</label>
        <wr-building-select id="buildingSelect" formControlName="building" [tenantId]="buildingTenantId()"></wr-building-select>
      </div>
      <div>
        <label class="label" for="dateRangePicker">Zeitraum</label>
        <wr-date-range-picker id="dateRangePicker" formControlName="dateRange"></wr-date-range-picker>
      </div>
      <div>
        <label class="label" for="maxDueDays">Status</label>
        <div>
          <nb-checkbox formControlName="expired">Abgelaufen</nb-checkbox>
        </div>
        <div>
          <nb-checkbox formControlName="notExpired">Nicht abgelaufen</nb-checkbox>
        </div>
        <input id="maxDueDays"
               formControlName="maxDueDays"
               nbInput
               type="number"
               fullWidth
               placeholder="läuft in weniger als X Tagen ab">
      </div>
      @if (isAdmin()) {
        <div>
          <label class="label" for="timerTenantSelect">Erstellt von</label>
          <wr-tenant-select id="timerTenantSelect" formControlName="timerTenantId"
                            placeholder="Ersteller auswählen"
                            [showEmptyOption]="true">
          </wr-tenant-select>
        </div>
      }
      <div>
        <label class="label" for="equipmentSelect">TGA Baupläne</label>
        <wr-tga-type-select id="equipmentSelect" formControlName="equipment"></wr-tga-type-select>
      </div>
      @if (isExternalTenant()) {
        <div>
          <nb-checkbox formControlName="myTeamOnly">Mein Team</nb-checkbox>
        </div>
      }
      @if (unresolvedLabels().length > 0) {
        <wr-banner status="warning"
                   [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
                   [message]="unresolvedHint()"></wr-banner>
      }
      <button nbButton type="submit" status="primary" fullWidth>
        <nb-icon icon="search-outline" pack="eva"></nb-icon>
        Suchen
      </button>
    </form>
  </nb-card-body>
</nb-card>
